import { Company } from '../model/index';

const CompanyCard = (props: Company): string => {
  // 検討リストへの追加
  // let favoIcon = '';
  // if (!props.favorite) {
  //   favoIcon = `

  //   `;
  // } else {
  //   favoIcon = `

  //   `;
  // }
  // ショーラベル
  let companyShow = '';
  if (props.name_tag) {
    companyShow = `
      <div class="text-white" style="padding:0 10px; width: fit-content; background-color: ${props.color_code}">
      ${props.name_tag}
      </div>
    `;
  }
  // ハッシュタグ
  let hashtag = '';
  let _hashtag = '';
  if (props.tag && props.tag.length > 0) {
    props.tag.forEach((item) => {
      _hashtag += `<a href="/result/?hashtag=${item}" class="text-dark campany-hashtag-text mr-4 pl-2 pr-2 border border-2 rounded">#${item}</a>`;
    });
  }
  if (_hashtag !== '') {
    hashtag = `
      <div class="row justify-content-start m-0">
        ${_hashtag}
      </div>
    `;
  }

  // 企業ロゴ
  let companyImage = '';
  if (props.image) {
    companyImage += `
      <div class="campany-logo-wrapper">
        <img
          class="campany-logo"
          src="${props.image}"
          onerror="this.src='/assets/img/noneUser.png'"
        />
      </div>
    `;
  }

  //　企業詳細
  let companyDescription = '';
  if (props.company_description && props.company_description.length > 60) {
    companyDescription += `
      <div>
        <p class="campany-description">
          ${props.company_description.slice(0, 60)} ...
        </p>
      </div>
    `;
  } else if (
    props.company_description &&
    props.company_description.length <= 60
  ) {
    companyDescription += `
      <div>
        <p class="campany-description">
          ${props.company_description} ///
        </p>
      </div>
    `;
  }

  let considerDeleteText: string = '';
  let considerAddText: string = '';
  if (!props.favorite) {
    considerDeleteText = `
    <div class="company-button company-button-star company-star  ml-lg-4" data-shop_id=${props.shop_id} data-favorite=${props.favorite}>
      <div>
        <img src="../assets/img/icon_list_add.png" class="company-button-icon company-star-icon"></img>
      </div>
      <p class="company-button-text company-button-text-star">
        <span class='trn' data-trn-key='refineConsider'>検討リスト</span>
        <span class='trn' data-trn-key='refineAdd'>に追加</span>
      </p>
    </div>
    <div class="company-button company-button-star company-star-active ml-lg-4 "  data-shop_id=${props.shop_id} data-favorite=${props.favorite} style='display: none; background-color: #009dff;' >
      <div>
        <img src="../assets/img/icon_list_delete.png" class="company-button-icon company-star-icon-active"></img>
      </div>
      <p class="company-button-text company-button-text-star">
        <span class='trn' data-trn-key='refineConsider' style='color: #fff;'>検討リスト</span>
        <span class='trn' data-trn-key='refineDelete' style='color: #fff;'>から削除</span>  
      </p>
    </div>
      `;
  } else {
    considerAddText = `
      <div class="company-button company-button-star company-star ml-lg-4" data-shop_id=${props.shop_id} data-favorite=${props.favorite} style='display: none'>
        <div>
        <img src="../assets/img/icon_list_add.png" class="company-button-icon company-star-icon"></img>
        </div>
        <p class="company-button-text company-button-text-star">
          <span class='trn ' data-trn-key='refineConsider'>検討リスト</span>
          <span class='trn ' data-trn-key='refineAdd'>に追加</span>
        </p>
      </div>
      <div class="company-button company-button-star company-star-active ml-lg-4 "  data-shop_id=${props.shop_id} data-favorite=${props.favorite} style='background-color: #009dff;' >
        <div>
          <img src="../assets/img/icon_list_delete.png" class="company-button-icon company-star-icon-active"></img>
        </div>
        <p class="company-button-text company-button-text-star">
          <span class='trn' data-trn-key='refineConsider' style='color: #fff;'>検討リスト</span>
          <span class='trn' data-trn-key='refineDelete' style='color: #fff;'>から削除</span>  
        </p>
      </div>
    `;
  }

  return /*html*/ `
  
    <div class="card mb-4">
    <div
    class="card-header"
    style="height: 15px; background-color: #67d1ff"
    ></div>
    ${companyShow}
    <div class="card-body pt-8 pb-8">
        <a
          href="${props.url}"
          target="_blank"
          style="text-decoration:none;color:inherit;"
        >
          <div class="card-text campany-card-content">
            ${companyImage}
            <div class="company-info">
              <div class="card-title">
                <div class="row justify-content-between m-0">
                  <span class="campany-title">
                    ${props.exhibition_name ?? ''}
                  </span>

                  <p class="text-muted">
                  <span class='trn' data-trn-key='productDate'>
                  
                    最終更新日 
                  </span>
                    ：
                    ${props.last_update}
                  </p>                  
                </div>
              </div>
              <h3 class="campany-heading">
                ${props.catch_copy ?? ''}
              </h3>
              ${companyDescription}
              <div class="company-button-wrapper justify-content-center justify-content-lg-end" style="display: flex;">
                <div class="company-button-top">
                  <a 
                    class="company-button btn btn-dark rounded-pill headr-auth__btn row justify-content-center m-0" 
                    style="display:flex; margin-right: 5%;"
                    href="${props.contact_url}"
                  >
                    <div>
                      <p class="company-button-text text-white font-weight-bold mb-0 trn" data-trn-key='contact'>お問い合わせ</p>
                    </div>  
                  </a>

                  <a 
                    class="company-button btn btn-dark rounded-pill headr-auth__btn row justify-content-center ml-2" 
                    style="display:flex;"
                    href="${props.url}"
                  >
                    <div>
                      <p class="company-button-text text-white font-weight-bold mb-0 trn" data-trn-key='refineCompanyUrl'>出展社ページへ</p>
                    </div>
                  </a>
                </div>

                <div class='campany-content' data-shop_id=${
                  props.shop_id
                } data-favorite=${props.favorite}>
                ${considerAddText}
                ${considerDeleteText}
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  `;
};
export default CompanyCard;
